import { RouteRecordRaw, createRouter, createWebHistory } from 'vue-router'

import BuilderPage from '@/pages/BuilderPage.vue'
import PreviewPage from '@/pages/PreviewPage.vue'
import { useAppStore } from '@/store/app'
import { Options } from '@gohighlevel/ghl-proposals-common'

export const routes: Readonly<RouteRecordRaw[]> = [
  {
    path: '/v2/location/:locationId/payments/proposals-estimates/edit/:documentId',
    component: BuilderPage,
    name: 'builder',
  },
  {
    path: '/v2/location/:locationId/payments/proposals-estimates/edit/:documentId/preview',
    component: PreviewPage,
    name: 'preview',
  },
]

export const parentRoutes = [
  {
    path: '/v2/location/:locationId/contacts/detail/:contactId',
    name: 'contact_detail-v2',
  },
  {
    path: '/v2/location/:locationId/payments/proposals-estimates',
    name: 'proposals-estimates',
  },
  {
    path: '/:version/location/:location_id/payments/invoices/:invoiceId',
    name: 'payment-products-invoice-editor',
  },
  {
    path: '/v2/location/:locationId/payments/proposals-estimates/templates/edit/:id',
    name: 'proposals-estimates-templates',
  },
  {
    path: '/v2/location/:locationId/payments/settings/taxes',
    name: 'payment-settings-taxes',
  },
  {
    path: '/:version/location/:location_id/payments/recurring-templates/v2/:scheduleId',
    name: 'payment-products-recurring-invoice-editor',
  },
  {
    path: '/v2/location/:locationId/marketing/templates',
    name: 'marketing-sms-templates',
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach((to, from, next) => {
  const appStore = useAppStore()

  if (from.name?.toString().includes('builder') && appStore.unsavedChanges) {
    // Let the component handle the navigation with the modal
    next(false)
    return
  }

  next()
})

export function emitRouteChangeToParent(
  path: string,
  options?: Options<string>
) {
  if (!path) return
  const store = useAppStore()
  try {
    if (store.handshake) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //@ts-ignore
      store.handshake.then((parent: any) => {
        parent.emit('route-change', {
          router: path,
          ...options,
        })
      })
    }
  } catch (error) {
    console.error(error)
  }
}

export { router }
